import { createContext } from "react";

export type ErrorModalContextValue = {
  showError: (message: string) => void;
};

export const ErrorModalContext = createContext<ErrorModalContextValue | undefined>(undefined);
